import React from 'react';
import classnames from 'classnames';
import { AttraqtSuggestionsProduct, ImageTransformation } from '../../../../../../../../types';
import Image from '../../../../../../../../components/image';
import productStyles from './product.module.pcss';
import { MessagePropertiesContext } from '../../../../../../../../contexts/messageProperties';

interface ProductProps {
  product: AttraqtSuggestionsProduct;
}

function Product({
  product: { url, imageUrl, price, name, manufacturer, wasPrice, productStatusOnListerPage }
}: ProductProps): React.ReactElement {
  const [formattedMessage] = React.useContext(MessagePropertiesContext);

  // TODO: Change transformation template
  return (
    <a tabIndex={0} href={url || ''} className={productStyles.product}>
      <Image
        src={imageUrl || ''}
        alt={name || ''}
        className={productStyles.product__image}
        transformationTemplates={{
          1: ImageTransformation.LOUATSSG,
          2: ImageTransformation.LOUATSSG_R
        }}
      />
      <div className={productStyles.product__description}>
        <span className={productStyles.product__brand}>{manufacturer}</span>
        <span className={productStyles.product__name}>{name}</span>
        <span
          className={classnames(productStyles.product__price, {
            [productStyles['product__price--discounted']]: wasPrice
          })}
        >
          {productStatusOnListerPage === 'PriceUponEnquiry'
            ? formattedMessage({ id: 'product.price.upon.enquiry', fallback: 'Price upon enquiry' })
            : price}
        </span>
      </div>
    </a>
  );
}

export default Product;
